<template>
    <!-- footer -->
    <div class="height-emulator fl-wrap"></div>
    <footer class="main-footer">
        <div class="container">
            <div class="footer-decor">
                <canvas id="bg-animation"></canvas>
            </div>
            <!-- footer-inner -->
            <div class="footer-inner fl-wrap">
                <div class="row">
                    <div class="col-md-4">
                        <div class="footer-logo">
                            <img :src="logoDark" :alt="siteName">
                        </div>
                        <div class="footer_text footer-box fl-wrap">
                            <p>{{ siteDescription }}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="footer-header fl-wrap">
                            <span>01.</span> Contacts
                        </div>
                        <!-- footer-contacts-->
                        <div class="footer-contacts footer-box fl-wrap">
                            <ul>
                                <li v-if="contactPhone">
                                    <span>Call:</span>
                                    <a :href="'tel:' + contactPhone">{{ contactPhone }}</a>
                                </li>
                                <li v-if="contactEmail">
                                    <span>Write:</span>
                                    <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
                                </li>
                                <li v-if="address">
                                    <span>Find us:</span>
                                    <a href="#">{{ address }}</a>
                                </li>
                            </ul>
                        </div>
                        <!-- footer contacts end -->
                        <a href="#" class="fc_button btn float-btn act-cf">
                            Get In Touch
                        </a>
                    </div>
                    <div class="col-md-4">
                        <div class="footer-header fl-wrap">
                            <span>02.</span> Subscribe
                        </div>
                        <div class="footer-box fl-wrap">
                            <p>Want to be notified when we launch a new template or an update. Just sign up and we'll send you a notification by email.</p>
                            <div class="subcribe-form fl-wrap">
                                <form id="subscribe" class="fl-wrap" @submit.prevent="subscribeNewsletter">
                                    <input 
                                        class="enteremail" 
                                        v-model="newsletterEmail"
                                        name="email" 
                                        id="subscribe-email" 
                                        placeholder="Your Email" 
                                        spellcheck="false" 
                                        type="email"
                                        :disabled="subscribing"
                                    >
                                    <button 
                                        type="submit" 
                                        id="subscribe-button" 
                                        class="subscribe-button"
                                        :disabled="subscribing"
                                    >Send</button>
                                    <label for="subscribe-email" class="subscribe-message"></label>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- footer-inner end -->
            <!-- subbfooter -->
            <div class="subbfooter fl-wrap">
                <div class="policy-box">
                    <span>&#169; {{ siteName }} {{ currentYear }} / All rights reserved.</span>
                </div>
                <div class="footer-solcial" v-if="socialLinks.length">
                    <ul>
                        <li v-for="(link, index) in socialLinks" :key="index">
                            <a :href="link.url || link.link" target="_blank">
                                {{ getSocialLabel(link.icon || link.name) }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="to-top-btn to-top">
                    <i class="fal fa-long-arrow-up"></i>
                </div>
            </div>
            <!-- subbfooter end -->
        </div>
    </footer>
    <!-- footer end -->
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'AppFooter',
    data() {
        return {
            pages: [],
            newsletterEmail: '',
            subscribing: false
        }
    },
    computed: {
        siteDefaultsStore() {
            return useSiteDefaultsStore()
        },
        logoLight() {
            return this.siteDefaultsStore.getLogoLight() || '/assets/img/logo.png'
        },
        logoDark() {
            return this.siteDefaultsStore.getLogoDark() || '/assets/img/logo2.png'
        },
        siteName() {
            return this.siteDefaultsStore.getSiteName() || 'Upatto'
        },
        contactEmail() {
            return this.siteDefaultsStore.getContactEmail() || ''
        },
        contactPhone() {
            return this.siteDefaultsStore.getContactPhone() || ''
        },
        address() {
            return this.siteDefaultsStore.getAddress() || ''
        },
        socialLinks() {
            return this.siteDefaultsStore.getSocialLinks() || []
        },
        siteDescription() {
            return this.siteDefaultsStore.getSiteDescription() || 
                ''
        },
        currentYear() {
            return new Date().getFullYear()
        }
    },
    async mounted() {
        console.log('🦶 AppFooter mounted, loading data...')
        console.log('Site defaults store:', this.siteDefaultsStore)
        
        // Load pages for footer links
        await this.loadPages()
    },
    methods: {        
        async loadPages() {
            try {
                const response = await this.$api.get('public/pages/list')
                if (response.data && response.data.status === 'success') {
                    this.pages = response.data.data.sort((a, b) => a.sort_order - b.sort_order)
                }
            } catch (error) {
                console.error('Failed to load pages:', error)
                this.pages = []
            }
        },
        
        async subscribeNewsletter() {
            if (!this.newsletterEmail.trim()) return
            
            this.subscribing = true
            
            try {
                const response = await this.$api.post('public/newsletter/subscribe', {
                    email: this.newsletterEmail
                })
                
                if (response.data && response.data.status === 'success') {
                    console.log('Newsletter subscription successful')
                    this.newsletterEmail = ''
                    // Show success message
                }
            } catch (error) {
                console.error('Newsletter subscription failed:', error)
            } finally {
                this.subscribing = false
            }
        },
        
        goToPage(slug) {
            this.$router.push({ name: 'pages', params: { slug: slug } })
        },
        
        getSocialLabel(icon) {
            const labelMap = {
                'facebook': 'Fb',
                'twitter': 'Tw',
                'instagram': 'In',
                'behance': 'Be',
                'linkedin': 'In',
                'pinterest': 'Pi'
            }
            
            const iconLower = (icon || '').toLowerCase()
            return labelMap[iconLower] || icon.substring(0, 2).toUpperCase()
        }
    }
}
</script>
